var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useGeneratedId } from 'modules/utils';
import { CountryAndInput } from './CountryAndInput';
import { PhoneInputContainer, PhoneInputLabel, PhoneInputDescription } from '../styled';
export function PhoneInput(props) {
    const { id: controlledId, label, description, stretch = false } = props, restProps = __rest(props, ["id", "label", "description", "stretch"]);
    const autoId = useGeneratedId('phoneinput');
    const id = controlledId || autoId;
    const describedBy = description ? `${id}-description` : undefined;
    return (<PhoneInputContainer $stretch={stretch}>
      {label && <PhoneInputLabel htmlFor={id}>{label}</PhoneInputLabel>}
      <CountryAndInput {...restProps} id={id} describedBy={describedBy}/>
      {description && <PhoneInputDescription id={describedBy}>{description}</PhoneInputDescription>}
    </PhoneInputContainer>);
}
